export const CLOSED_MENU_WIDTH = 76;
